import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common/common.service';
import { ContactService } from 'src/app/services/register-data/contacts/contact.service';
import { ValidatorService } from 'src/app/services/validators/errors-validators.service';
import { Contact } from 'src/models/interfaces/contacts/contact-interface';
import { TypeAccess } from 'src/models/interfaces/input-interface';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DATE_FORMAT_YEARLESS } from 'src/models/interfaces/date-format.interface';
import { Department } from 'src/models/interfaces/departments/department.interface';
import { Role } from 'src/models/interfaces/role.interface';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { Subscription } from 'rxjs';
import { MeioContato } from 'src/models/interfaces/contacts/meio-contato-interface';
import { TipoMeioContato } from 'src/models/interfaces/contacts/tipo-meio-contato-interface';
import { HomeComponent } from 'src/app/home/home/home.component';
import { menuOptions } from 'src/data/menu-options.data';
import { listaFlagSimNao, listaGeneros } from 'src/models/const';

@Component({
    selector: 'spe-detalhes',
    templateUrl: './contato-detalhes.component.html',
    styleUrls: ['./contato-detalhes.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT_YEARLESS }
    ],
    standalone: false
})
export class ContatoDetalhesComponent implements OnInit {
  listDepartment: Department[] = [];
  listRoles: Role[] = [];
  listFlagResponsible: TypeAccess[] = listaFlagSimNao;
  listGender: TypeAccess[] = listaGeneros;
  listTypeRegister: TipoMeioContato[] = [];
  isTelTipEditEmail: Array<boolean> = [];
  public statusCommAPI: string | null = null;
  isTelTipAddEmail = false;
  contactId: number = 0;
  objectFormControl = Object;
  public nav = this.routerService.getCurrentNavigation();
  public message: string = '';
  public apiStatus: string | null = null;
  private originalContact?: Contact;
  private subscriptions: Subscription[] = [];
  public meioContatoPrincipal?: MeioContato;
  public meioContatoSecundario?: MeioContato;
  public meiosContato: MeioContato[] = [];
  validatorErrors = this.validatorService.validatorErrors;
  public sigla = localStorage.getItem('sigla');

  public contactDataForm = new FormGroup({
    nomeContato: new FormControl('', [Validators.required]),
    descricaoDepartamento: new FormControl('', [Validators.required]),
    descricaoCargo: new FormControl('', [Validators.required]),
    sexo: new FormControl('', [Validators.required]),
    dataAniversario: new FormControl(new Date(), [Validators.required]),
    flagResponsavel: new FormControl('', [Validators.required]),
    descricao: new FormControl('', [Validators.required, Validators.email]),
    secundaryEmail: new FormControl('', [Validators.email])
  });

  public registerListDataForm = new FormGroup({
    register: this.formBuilder.array([])
  });

  public registerDataForm = new FormGroup({
    typeNumber: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required]),
    branch: new FormControl(''),
    tipEmail: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    public readonly routerService: Router,
    public readonly contactService: ContactService,
    public readonly validatorService: ValidatorService,
    public readonly formBuilder: FormBuilder,
    public readonly commonService: CommonService,
    private messageService: MessageService,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit(): void {
    this.setHomeVariables();
    this.subscribeMessageService();
    this.contactId = Number(this.routerService.routerState.snapshot.url.split('/')[4]);
    this.registerDataForm.controls['tipEmail'].disable();
    this.getContatos();
    this.getInformacoesContato();
  }

  private setHomeVariables() {
    this.homeComponent.setNewVariables(
      'Contatos',
      'Mantenha sempre os contatos atualizados para que possamos comunicá-lo com maior agilidade.'
    );
    this.homeComponent.idleMenuContent = menuOptions[0].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_businesspeople.png';
  }

  private subscribeMessageService() {
    const messageSubscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      if (errorData.errorMessage != 'Cliente encontrado com sucesso.') {
        this.showMessage(errorData.errorMessage, errorData.isError);
      }
    });
    this.subscriptions.push(messageSubscription);
  }

  private getInformacoesContato() {
    const subscriptionD = this.contactService.getContactsDepartments().subscribe((data) => {
      this.listDepartment = data;
    });
    this.subscriptions.push(subscriptionD);

    const subscriptionR = this.contactService.getContactsRoles().subscribe((data) => {
      this.listRoles = data;
    });
    this.subscriptions.push(subscriptionR);

    const subscriptionMT = this.contactService.getMeiosContatoTipo().subscribe((data) => {
      this.listTypeRegister = data;
    });
    this.subscriptions.push(subscriptionMT);
  }

  private getContatos() {
    const subscription = this.contactService.getContacts().subscribe((data) => {
      const thisContact = data.find((data) => data.idContato === this.contactId);
      let date: Date | null = null;
      if (thisContact != null && thisContact?.dataAniversario != null) {
        const birthDay = thisContact?.dataAniversario.substring(0, 2);
        const birthMonth = thisContact?.dataAniversario.substring(2);
        const strDate = '2000' + '-' + birthMonth + '-' + birthDay + 'T00:00:00';
        date = new Date(strDate);
      } else {
        date = null;
      }
      this.originalContact = thisContact;

      this.contactDataForm.patchValue({
        nomeContato: thisContact!.nomeContato,
        descricaoDepartamento: thisContact!.descricaoDepartamento,
        descricaoCargo: thisContact!.descricaoCargo,
        sexo: thisContact!.sexo,
        dataAniversario: date,
        flagResponsavel: thisContact!.flagResponsavel,
        descricao: thisContact!.descricao
      });

      const subscriptionM = this.contactService.getMeiosContato(this.contactId).subscribe({
        next: (data) => {
          this.meiosContato = data;
          this.meioContatoPrincipal = data.find(
            (meioContato: MeioContato) => meioContato.tipo === 6 && meioContato.flagPrincipal === 'S'
          );
          this.meioContatoSecundario = data.find(
            (meioContato: MeioContato) => meioContato.tipo === 6 && meioContato.flagPrincipal === 'N'
          );
          if (this.meioContatoSecundario != null) {
            this.contactDataForm.patchValue({
              secundaryEmail: this.meioContatoSecundario.descricao ?? null
            });
          }
          if (this.meioContatoPrincipal != null) {
            let index = this.meiosContato.indexOf(this.meioContatoPrincipal);
            this.meiosContato.splice(index, 1);
          }
          if (this.meioContatoSecundario != null) {
            let index = this.meiosContato.indexOf(this.meioContatoSecundario);
            this.meiosContato.splice(index, 1);
          }
          if (this.meiosContato.length > 0) {
            for (let index = 0; index < this.meiosContato.length; index++) {
              if (this.meiosContato[index].id === this.meioContatoPrincipal?.id) continue;
              if (this.meiosContato[index].id === this.meioContatoSecundario?.id) continue;
              this.initRegister(this.meiosContato[index]);
            }
          }
          this.isTelTipAddEmail = false;
        }
      });
      this.subscriptions.push(subscriptionM);
    });
    this.subscriptions.push(subscription);
  }

  private initRegister = (meioContato: MeioContato) => {
    if (meioContato.tipo === 10 || meioContato.tipo === 6) {
      this.isTelTipEditEmail.push(true);
    } else {
      this.isTelTipEditEmail.push(false);
    }
    this.registerDataForm.markAllAsTouched();
    this.register.push(
      this.formBuilder.group({
        registerTypeNumber: new FormControl(meioContato.tipo, [Validators.required]),
        registerNumber: new FormControl(meioContato.descricao, [Validators.required]),
        registerBranch: new FormControl(meioContato.complemento),
        registerTipEmail: new FormControl(meioContato.descricao, [Validators.required])
      })
    );
    const index = Object(this.registerListDataForm.controls['register']).controls.length - 1;

    const value = Object(this.registerListDataForm.controls['register']).controls[index].controls.registerTypeNumber
      .value;

    if (value === 10 || value === 6) {
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerTipEmail.enable();
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerNumber.disable();
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerBranch.disable();
    } else {
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerTipEmail.disable();
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerNumber.enable();
      Object(this.registerListDataForm.controls['register']).controls[index].controls.registerBranch.enable();
    }
    this.registerDataForm.markAsUntouched();
  };

  public addRegister = (type: string, number: string, ramal: string, tipEmail: string) => {
    let newMeioContato;
    this.registerDataForm.markAllAsTouched();
    if (this.registerDataForm.valid) {
      if (type.toString() === '10' || type.toString() === '6') {
        newMeioContato = {
          _complemento: '',
          descricao: this.registerDataForm.controls.tipEmail.value?.toLowerCase(),
          idContato: this.contactId,
          tipo: this.registerDataForm.controls.typeNumber.value
        };
      } else {
        newMeioContato = {
          complemento: this.registerDataForm.controls.branch.value,
          descricao: this.registerDataForm.controls.number.value,
          idContato: this.contactId,
          tipo: this.registerDataForm.controls.typeNumber.value
        };
      }

      this.contactService.addMeiosContato(newMeioContato).subscribe({
        next: (data) => {
          let typeRegister = this.listTypeRegister.find((value: TipoMeioContato) => {
            return value.id.toString() === type.toString();
          });

          if (typeRegister != undefined) {
            this.showMessage(`${typeRegister?.descricao} incluído com sucesso!`);
          }

          if (tipEmail == '') {
            this.isTelTipEditEmail.push(false);
          } else {
            this.isTelTipEditEmail.push(true);
          }

          this.meiosContato.push(data.meioContato);
          this.register.push(
            this.formBuilder.group({
              registerTypeNumber: new FormControl(type, [Validators.required]),
              registerNumber: new FormControl(number, [Validators.required]),
              registerBranch: new FormControl(ramal),
              registerTipEmail: new FormControl(tipEmail, [Validators.required])
            })
          );

          const index = Object(this.registerListDataForm.controls['register']).controls.length - 1;
          const value = Object(this.registerListDataForm.controls['register']).controls[index].controls
            .registerTypeNumber.value;

          if (value === 10 || value === 6) {
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerTipEmail.enable();
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerNumber.disable();
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerBranch.disable();

            this.isTelTipAddEmail = true;
          } else {
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerTipEmail.disable();
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerNumber.enable();
            Object(this.registerListDataForm.controls['register']).controls[index].controls.registerBranch.enable();
            this.isTelTipAddEmail = false;
          }

          this.registerDataForm.setValue({
            typeNumber: '',
            number: '',
            branch: '',
            tipEmail: ''
          });
          this.registerDataForm.markAsUntouched();
        },
        error: () => {}
      });

      this.commonService.autoScroll();
    }
  };

  public readonly deleteRegister = (index: number, register: AbstractControl<any, any>) => {
    let itemToDelete: MeioContato | undefined;
    if (register.value['registerTypeNumber'] === 10 || register.value['registerTypeNumber'] === 6) {
      itemToDelete = this.meiosContato.find(
        (value: MeioContato) => value.descricao === register.value['registerTipEmail']
      );
    } else {
      itemToDelete = this.meiosContato.find(
        (value: MeioContato) => value.descricao === register.value['registerNumber']
      );
    }
    let indexMeiosContato = this.meiosContato.findIndex((value: MeioContato) => itemToDelete?.id === value.id);

    this.contactService.deleteMeiosContato(itemToDelete!.id).subscribe({
      next: () => {
        let typeRegister = this.listTypeRegister.find((value: TipoMeioContato) => {
          return value.id.toString() === itemToDelete?.tipo.toString();
        });

        if (typeRegister != undefined) {
          this.showMessage(`${typeRegister?.descricao} excluído com sucesso!`);
        }
        this.registerListDataForm.controls['register'].removeAt(index);
        this.isTelTipEditEmail.splice(index, 1);
        this.meiosContato.splice(indexMeiosContato, 1);
      },
      error: () => {}
    });
    this.commonService.autoScroll();
  };

  public readonly updateRegister = (index: number, register: AbstractControl<any, any>) => {
    let update;
    const originalMeioContato = this.meiosContato[index];
    const newMeioContato = Object(this.registerListDataForm.controls['register']).controls[index];

    if (newMeioContato.value['registerTypeNumber'] === 10 || newMeioContato.value['registerTypeNumber'] === 6) {
      if (
        originalMeioContato.descricao != newMeioContato.value['registerTipEmail'] ||
        originalMeioContato.tipo != newMeioContato.value['registerTypeNumber']
      ) {
        update = {
          _complemento: '',
          descricao: newMeioContato.value['registerTipEmail'].toLowerCase(),
          idContato: this.contactId,
          tipo: newMeioContato.value['registerTypeNumber'],
          id: originalMeioContato.id
        };
        this.updateRegisterMethod(update);
      } else {
        this.showMessage('O registro não foi alterado.');
        this.commonService.autoScroll();
      }
    } else {
      if (
        originalMeioContato.descricao != newMeioContato.value['registerNumber'] ||
        originalMeioContato.complemento != newMeioContato.value['registerBranch'] ||
        originalMeioContato.tipo != newMeioContato.value['registerTypeNumber']
      ) {
        update = {
          complemento: newMeioContato.value['registerBranch'],
          descricao: newMeioContato.value['registerNumber'],
          idContato: this.contactId,
          tipo: newMeioContato.value['registerTypeNumber'],
          id: originalMeioContato.id
        };
        this.updateRegisterMethod(update);
      } else {
        this.showMessage('O registro não foi alterado.');
        this.commonService.autoScroll();
      }
    }
  };

  private readonly updateRegisterMethod = (update: any) => {
    this.contactService.putMeiosContato(update).subscribe({
      next: (data) => {
        let typeRegister = this.listTypeRegister.find((value: TipoMeioContato) => {
          return value.id.toString() === update?.tipo.toString();
        });

        if (typeRegister != undefined) {
          this.showMessage(`${typeRegister?.descricao} alterado com sucesso!`);
        }

        let indexToRemove = this.meiosContato.findIndex((value: MeioContato) => {
          return value.id === update.id;
        });
        this.meiosContato.splice(indexToRemove, 1, data);
      }
    });
    this.commonService.autoScroll();
  };

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public readonly returnButton = () => {
    this.routerService.navigate(['/home/dadosEmpresa/contato']);
  };

  public readonly saveContact = () => {
    this.contactDataForm.markAllAsTouched();
    const formValid: boolean = this.contactDataForm.valid && this.registerListDataForm.controls['register'].valid;
    if (!this.contactDataForm.dirty) {
      this.showMessage('Nenhum campo alterado!');
    } else if (formValid) {
      this.contactService.putContact(this.updateContact() as Contact).subscribe({
        next: () => {},
        error: () => {}
      });
    }
    this.commonService.autoScroll();
  };

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  private readonly updateContact = (useOriginalContact: boolean = false) => {
    const listRegister: Array<any> = [];
    let contactToSave;
    Object(this.registerListDataForm.controls['register'].controls).forEach((element: FormGroup) => {
      listRegister.push({
        type: element.controls['registerTypeNumber'].value ?? '',
        number: element.controls['registerNumber'].value ?? '',
        ramal: element.controls['registerBranch'].value ?? '',
        email: element.controls['registerTipEmail'].value ?? ''
      });
    });
    if (useOriginalContact) {
      contactToSave = {
        ...this.originalContact
      };
    } else {
      const newDate = new Date(this.contactDataForm.controls.dataAniversario!.value!);
      let newDateStr = newDate?.toLocaleDateString('pt-BR');
      newDateStr = newDateStr?.substring(0, 5);
      const newDepartment = this.listDepartment.find(
        (value) => value.descricao === this.contactDataForm.controls.descricaoDepartamento.value
      );
      const newRole = this.listRoles.find(
        (value) => value.descricao === this.contactDataForm.controls.descricaoCargo.value
      );

      const newPrimaryEmail = {
        _complemento: '',
        descricao: this.contactDataForm.controls.descricao.value?.toLowerCase(),
        idContato: this.contactId,
        tipo: 6,
        id: this.meioContatoPrincipal?.id
      };

      const newSecundaryEmail = {
        _complemento: '',
        descricao: this.contactDataForm.controls.secundaryEmail.value?.toLowerCase(),
        idContato: this.contactId,
        tipo: 6,
        id: this.meioContatoSecundario?.id
      };

      const newMeiosContato =
        this.contactDataForm.controls.secundaryEmail.value === ''
          ? [newPrimaryEmail]
          : [newPrimaryEmail, newSecundaryEmail];

      contactToSave = {
        aniversario: newDateStr,
        flagResponsavelCompra: this.contactDataForm.controls.flagResponsavel.value,
        idCargo: newRole?.id,
        idDepartamento: newDepartment?.id,
        nomeContato: this.contactDataForm.controls.nomeContato.value,
        sexo: this.contactDataForm.controls.sexo.value,
        id: this.contactId,
        meiosContato: newMeiosContato
      };
    }
    if (this.meioContatoSecundario != null) {
      if (this.meioContatoSecundario?.descricao != '' && this.contactDataForm.controls.secundaryEmail.value === '') {
        this.contactService.deleteMeiosContato(this.meioContatoSecundario.id).subscribe({
          next: () => {},
          error: () => {}
        });
      }
    }
    return contactToSave;
  };

  get contactDataFormControl() {
    return this.contactDataForm.controls;
  }

  get registerDataFormControl() {
    return this.registerDataForm.controls;
  }

  get registerListDataFormControl() {
    return this.registerListDataForm.controls;
  }
  get register() {
    return this.registerListDataForm.get('register') as FormArray;
  }
  get registercontrol() {
    return this.register.controls;
  }

  public readonly telTipEditSelect = (value: any): void => {
    const index = Object(this.registerListDataForm.controls['register'].value[value])['registerTypeNumber'];
    if (index === 10 || index === 6) {
      this.isTelTipEditEmail[value] = true;
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerTipEmail.enable();
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerNumber.disable();
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerBranch.disable();
    } else {
      this.isTelTipEditEmail[value] = false;
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerTipEmail.disable();
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerNumber.enable();
      Object(this.registerListDataForm.controls['register']).controls[value].controls.registerBranch.enable();
    }
  };

  public readonly telTipAddSelect = (value: any): void => {
    if (value === 10 || value === 6) {
      this.registerDataForm.controls['tipEmail'].enable();
      this.registerDataForm.controls['number'].disable();
      this.registerDataForm.controls['branch'].disable();
      this.isTelTipAddEmail = true;
    } else {
      this.registerDataForm.controls['tipEmail'].disable();
      this.registerDataForm.controls['number'].enable();
      this.registerDataForm.controls['branch'].enable();
      this.isTelTipAddEmail = false;
    }
  };
}
